<template>
  <table-list
    idKey="id"
    :listConfig="listConfig"
    :apis="apis"
    :createFrom="fromConfig"
    :btn-config="btnConfig"
    @handleBtn="handleBtn"
    :btnConfig="btnConfig | filterBtnsRole($route)"
  >
    <div slot="imageUrl" slot-scope="data">
      <el-image v-for="(url, index) in data.row.imageUrl.split(',')" :key="index"
                style="width: 50px; height: 50px;margin-right: 5px" :src="url"
                :preview-src-list="data.row.imageUrl.split(',')"/>
    </div>
  </table-list>
</template>

<script>
import config from "./config/carousel.config";
export default {
  data() {
    return {
      ...config(),
    };
  },
  methods: {
    handleBtn() {

    }
  }
};
</script>
